import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MobileFormatPipeModule } from '@pipes/mobile-format/mobile-format.module';
import { PossibleDuplicateContactComponent } from './possible-duplicate-contact.component';

@NgModule({
  declarations: [PossibleDuplicateContactComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, DialogModule, RadioButtonModule, MobileFormatPipeModule],
  exports: [PossibleDuplicateContactComponent],
})
export class PossibleDuplicateContactModule {}
